import DapDSLabel from './label.component'

export * from './label.component'
export default DapDSLabel

DapDSLabel.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-label': DapDSLabel
  }
}
